import { AxiosError } from 'axios';
import { IErrorResponseData } from 'src/services/Types';

/**
 *
 * @param axiosError
 * @returns - string
 */
const getErrorMessage = (axiosError: AxiosError<IErrorResponseData, any>) => {
  const errorArray = axiosError?.response?.data?.errors;
  return Array.isArray(errorArray) ? errorArray[0].message : axiosError.message;
};

export default getErrorMessage;
